import React, { useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Card, CardBody, Nav, NavItem, NavLink } from "react-bootstrap";
import { TabContent, TabPane } from "reactstrap";
import BreadCrumbs from "../../../components/BreadCrumbs";
import CustomerTopUpWallet from "./CustomerTopUpWallet";
import CustomerDetailView from "./CustomerDetailView";

// Create navigation list for customer tabs
const NAV_LIST_CUSTOMER_VIEW = [
  { id: 1, name: "Customer Details" },
  { id: 2, name: "Top Up Wallet" },
];

const CustomerView = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();

  const [active, setActive] = useState(1);
  const toggle = (tab: number) => {
    setActive(tab);
  };

    const customer = location.state?.customer;
  const customerName = customer?.displayName || 'Customer Details';

  const breadcrumbNameMap = {
    [id!]: customerName 
  };


  return (
    <>
      <BreadCrumbs hasSubMenus={true}  customNameMap={breadcrumbNameMap}/>
      <br />
      <Card className="customer-view-whole-card">
        <CardBody>
          {/* Tab Navigation */}
          <Nav variant="pills" className="mb-3 customer-nav-tabs">
            {NAV_LIST_CUSTOMER_VIEW.map((item) => (
              <NavItem key={item.id}>
                <NavLink
                  active={active === item.id}
                  onClick={() => toggle(item.id)}
                  style={{ 
                    cursor: "pointer",
                    backgroundColor: active === item.id ? "#0d6efd" : "transparent",
                    color: active === item.id ? "#1f0a0a" : "#6c757d", // Fixed color contrast
                    fontWeight: active === item.id ? "600" : "normal"
                  }}
                >
                  {item.name}
                </NavLink>
              </NavItem>
            ))}
          </Nav>
          
          <hr />
          
          {/* Tab Content */}
          <TabContent activeTab={active} className="mt-4">
            <TabPane tabId={1} className={active === 1 ? "active" : ""}>
              {active === 1 && (
                <div className="sub-nav-bar-each-part">
                  <CustomerDetailView customerId={id} />
                </div>
              )}
            </TabPane>
            
            <TabPane tabId={2} className={active === 2 ? "active" : ""}>
              {active === 2 && (
                <div className="sub-nav-bar-each-part">
                  <CustomerTopUpWallet customerId={id} />
                </div>
              )}
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </>
  );
};

export default CustomerView;